import React from "react";
import { useAuthStore } from "../../stores/authStore";
import { useNavigate } from "react-router-dom";
import { AnalyticsDashboard } from "../../components/business/AnalyticsDashboard";
import { useBusinessData } from "../../hooks/useBusinessData";
import { useAnalytics } from "../../hooks/useAnalytics";
import Sidebar from "../../components/layout/Sidebar";

const AnalyticsPage: React.FC = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const { business } = useBusinessData();
  const { analytics, loading } = useAnalytics(business?.id);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch {
      // Optionally handle logout error
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar Navigation */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="bg-white shadow-sm border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center">
                <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
              </div>
              <div className="flex items-center space-x-4">
                <span className="text-sm text-gray-600">
                  {user?.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="flex-1 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="space-y-8">
            <AnalyticsDashboard analytics={analytics} loading={loading} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AnalyticsPage;